import Collapsable from '@/components/collapsable/component'
import TextComponent from '@/components/text/component'
import ContactForm from '@/components/contact-form/component'

export default {
  name: 'faq-page',
  components: { Collapsable, TextComponent, ContactForm }
}



// WEBPACK FOOTER //
// ./src/pages/faq/script.js